import { useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import { newIdempotencyId, parseConvexError } from "../lib/utils";
import { hasConvexConfig, hasWorkOsConfig } from "../lib/config";

export function LocationsPage() {
  if (!hasConvexConfig || !hasWorkOsConfig) {
    return (
      <div className="page">
        <h1>Locations</h1>
        <p className="lede">Configure auth to manage warehouses.</p>
      </div>
    );
  }
  return <LocationsAuthenticated />;
}

function LocationsAuthenticated() {
  const locations = useQuery(api.locations.list);
  const createLocation = useMutation(api.locations.create);
  const [name, setName] = useState("");
  const [type, setType] = useState<"warehouse" | "amazon" | "other">("warehouse");
  const [address, setAddress] = useState("");
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Locations</h1>
          <p className="lede">Warehouses and destinations for stock balances.</p>
        </div>
      </div>

      <section className="panel" style={{ padding: 0, marginBottom: "1rem" }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>SKUs</th>
              <th>Units</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {(locations ?? []).map((loc) => (
              <tr key={loc._id}>
                <td>{loc.name}</td>
                <td>{loc.locationType}</td>
                <td>{loc.skuCount}</td>
                <td>{loc.unitCount}</td>
                <td className="muted tiny">{loc.address ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="panel">
        <h2 className="panel-title">Add location</h2>
        <div className="header-fields">
          <label className="field">
            <span>Name</span>
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label className="field">
            <span>Type</span>
            <select value={type} onChange={(e) => setType(e.target.value as typeof type)}>
              <option value="warehouse">Warehouse</option>
              <option value="amazon">Amazon</option>
              <option value="other">Other</option>
            </select>
          </label>
        </div>
        <label className="field">
          <span>Address</span>
          <input value={address} onChange={(e) => setAddress(e.target.value)} />
        </label>
        {error && <p className="error">{error}</p>}
        <button
          type="button"
          className="btn primary"
          onClick={() => {
            void (async () => {
              try {
                setError(null);
                await createLocation({
                  name,
                  locationType: type,
                  address: address || undefined,
                  idempotencyId: newIdempotencyId("loc"),
                });
                setName("");
                setAddress("");
              } catch (err) {
                setError(parseConvexError(err).message);
              }
            })();
          }}
        >
          Add location
        </button>
      </section>
    </div>
  );
}
